import { useState, useEffect } from "react";
import { IconButton, Box, Image } from "@chakra-ui/react";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const FlashButtons = () => {
 const [showButtons, setShowButtons] = useState(true);

 useEffect(() => {
  setShowButtons(true);

  const interval = setInterval(() => {
   setShowButtons(true); // Show for 1 minute
   const timeout = setTimeout(() => {
    setShowButtons(false); // Hide for the next 4 minutes
   }, 60000); // Hide after 1 minute

   return () => clearTimeout(timeout);
  }, 300000); // Every 5 minutes

  return () => clearInterval(interval);
 }, []);

 return (
  <>
   {showButtons && (
    <>
     <Box position="fixed" bottom="20px" left="20px" zIndex="1000">
      <IconButton
       icon={<FaPhone style={{ fontSize: "28px" }} />}
       colorScheme="blue"
       boxSize="50px"
       borderRadius="full"
       onClick={() => window.open("tel:+919650865123")}
       animation="flash 1.5s infinite"
       aria-label="Call"
      />
     </Box>
    </>
   )}
  </>
 );
};

export default FlashButtons;
